import React from 'react';
import { FaUniversity, FaBoxOpen, FaRocket, FaHandshake } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function EducationalCourierService() {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[500px] md:h-[700px]"
        style={{ backgroundImage: "url('images/university.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-5xl md:text-7xl font-semibold tracking-tight text-shadow-md">
            Reliable Educational Courier Services
          </h1>
          <p className="text-xl md:text-2xl mt-4 max-w-lg mx-auto text-shadow-md">
            Delivering your educational materials with speed, safety, and precision.
          </p>
        </div>
      </div>

      {/* Services Section */}
      <section id="services" className="py-24 bg-white text-black">
        <div className="container mx-auto px-6">
          <h2 className=" text-3xl md:text-5xl font-thin text-center mb-12">Our Key Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-12">
            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-xl shadow-lg p-8 transition-transform transform hover:scale-105 hover:shadow-xl duration-300">
              <div className="text-6xl mb-6 ">
                <FaUniversity />
              </div>
              <h3 className="text-2xl font-thin mb-4">University-to-University Shipping</h3>
              <p className="text-lg leading-relaxed max-w-xs mx-auto font-thin">
                Secure and swift transport of educational materials between universities or institutions.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-xl shadow-lg p-8 transition-transform transform hover:scale-105 hover:shadow-xl duration-300">
              <div className="text-6xl mb-6 ">
                <FaBoxOpen />
              </div>
              <h3 className="text-2xl font-thin mb-4">Textbook and Material Delivery</h3>
              <p className="text-lg leading-relaxed max-w-xs mx-auto font-thin">
                Fast delivery of textbooks, study materials, and other educational resources directly to students and staff.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-xl shadow-lg p-8 transition-transform transform hover:scale-105 hover:shadow-xl duration-300">
              <div className="text-6xl mb-6 ">
                <FaRocket />
              </div>
              <h3 className="text-2xl font-thin mb-4">Express Shipping Services</h3>
              <p className="text-lg leading-relaxed max-w-xs mx-auto font-thin">
                For urgent deliveries of time-sensitive educational materials to students, faculties, and departments.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-xl shadow-lg p-8 transition-transform transform hover:scale-105 hover:shadow-xl duration-300">
              <div className="text-6xl mb-6 ">
                <FaHandshake />
              </div>
              <h3 className="text-2xl font-thin mb-4">Partnership Solutions</h3>
              <p className="text-lg leading-relaxed max-w-xs mx-auto font-thin">
                We offer customized courier solutions for educational institutions, ensuring seamless operations and reliable service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="xl:py-24 bg-white text-black">
        <div className="container mx-auto px-6">
          <h2 className=" text-2xl md:text-5xl font-thin text-center mb-12 text-black">What Our Clients Say</h2>
          <div className="flex  flex-col md:flex-row gap-10 justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md">
              <p className="text-lg text-gray-700 mb-4 font-thin">
                "The courier service is incredibly reliable. Our textbooks and materials always arrive on time, and the service is smooth and hassle-free. It’s a huge help for our students and staff."
              </p>
              <p className="font-thin text-gray-800">Sarah, University Coordinator</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md">
              <p className="text-lg text-gray-700 mb-4 font-thin">
                "As a school, we rely heavily on fast delivery for course kits and materials. This service has been a game-changer. We can always count on timely deliveries every time."
              </p>
              <p className="font-thin text-gray-800">Michael, Head of Logistics</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="bg-white text-black py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-thin mb-4">Get Started with Educational Courier Services Today</h2>
          <p className="text-lg mb-8 font-thin">Let us handle your educational material deliveries so you can focus on what matters most—education.</p>
          <div className='flex justify-center'>
      <Link to='/contactus'>
    <button className="bg-slate-900 text-white font-semibold py-3 px-8   ">Contact us</button></Link>
    </div>
        </div>
      </section>
    </div>
  );
}

export default EducationalCourierService;
